import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IUserSlice, TCart } from "@/redux/slices/user/types";

export const getCart = createAsyncThunk(
  "user/getCart",
  async () => await axios.get("/svc/cart/items").then((res) => res.data.cart)
);

const pending = (state: IUserSlice) => {
  state.cart.loading = true;
};

const fulfilled = (state: IUserSlice, { payload }: { payload: TCart }) => {
  state.cart = {
    ...payload,
    uuid: payload?.uuid || state.cart?.uuid,
    items: payload.items.map((item) => ({
      ...item,
      loading: false,
    })),
  };
};

const rejected = (state: IUserSlice) => {
  state.cart.loading = false;
};

export default {
  action: getCart,
  pending,
  fulfilled,
  rejected,
};
